import { render, staticRenderFns } from "./Editoriales.vue?vue&type=template&id=aa9fd82e&"
import script from "./Editoriales.vue?vue&type=script&lang=js&"
export * from "./Editoriales.vue?vue&type=script&lang=js&"
import style0 from "./Editoriales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAutocomplete,VCol,VContainer,VForm})
